import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'

export default new Controller({
  name: '_',
  route: '#/*path',
  controller (Router, evt, _) {
    const { path } = evt.params
    const { queryString } = evt
    const redirectTo = (typeof queryString === 'string') && queryString ? path + '?' + queryString : path
    replaceUrl(redirectTo)
    return evt.url
  }
})
